import { render, staticRenderFns } from "./question-detail.vue?vue&type=template&id=9e13aee6&scoped=true&"
import script from "./question-detail.vue?vue&type=script&lang=js&"
export * from "./question-detail.vue?vue&type=script&lang=js&"
import style0 from "./question-detail.vue?vue&type=style&index=0&id=9e13aee6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e13aee6",
  null
  
)

export default component.exports